// removed by extract-text-webpack-plugin
module.exports = {"componentModal":"componentModal___3JFux"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ComponentModal/styles.less
// module id = YGHA
// module chunks = 18